module.exports = __webpack_public_path__ + "img/progress_062.2c5fe81b.png";